import { EmployerAgreementsService_employerAgreementsVersionsServiceGetLatestEntity } from '@festina/life-general-types/life/hooks/EmployerAgreementsService_employerAgreementsVersionsServiceGetLatestEntity'

export const useFetchEmployerAgreementVersionLatestNoSuspense =
  EmployerAgreementsService_employerAgreementsVersionsServiceGetLatestEntity.useQuery
